import React from 'react'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { CsClockIcon } from '../../legacy-design-system/icons'
interface EmptyActivityPanelProps {
  readonly title: string
  readonly subtitle: string
}

export function EmptyActivityPanel({
  title,
  subtitle
}: EmptyActivityPanelProps) {
  return (
    <div
      className={css`
        margin-bottom: 20px;
        background-color: ${theme.color.white};
        border: 1px solid ${theme.color.transparent};
        border-radius: 4px;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
        border-color: ${theme.color.neutral30};
        padding: 50px 60px;
        text-align: center;
      `}
    >
      <CsClockIcon
        className={css`
          text-align: center;
        `}
        size="58"
        color="neutral50"
      />

      <div
        className={css`
          text-align: center;
          font-size: 21px;
          font-weight: bolder;
          color: ${theme.color.neutral90};
        `}
      >
        <span>{title}</span>
      </div>
      <div
        className={css`
          text-align: center;
          font-size: 14px !default;
          color: ${theme.color.neutral70};
        `}
      >
        <span>{subtitle}</span>
      </div>
    </div>
  )
}
